import React from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import { INoDataProps } from './NoData.types';

const NoData = ({ ...props }: INoDataProps) => {
  const { t } = useTranslation();

  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('common.noData')} {...props} />;
};

export default NoData;
